import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "./scss/global.scss";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({ render: createElement => createElement(App) }).$mount('#app');